import envData from '../env.json';

interface EnvConfig {
  [key: string]: string;
}

let envConfig: EnvConfig | null = null;

export function loadEnv(): void {
  console.log('Loading environment configuration...');
  const hostname = window.location.hostname;
  let stack = 'local'; // Default stack

  if (hostname.includes('portalshell.int.hp.com')) {
    const parts = hostname.split('.');
    stack = parts[1]; // Get the second value from the hostname
  } else if (hostname && !hostname.includes('localhost')) {
    stack = 'prod';
  }

  try {
    const data = envData as { [key: string]: EnvConfig };
    if (!data[stack]) {
      throw new Error(`Unknown stack: ${stack}`);
    }
    envConfig = data[stack];
    console.log('Loaded environment configuration:', envConfig);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export function getEnv(envName: string): string {
  if (!envConfig) {
    // throw new Error('Environment configuration not loaded.');
    loadEnv();
  }

  if (!(envName in envConfig)) {
    throw new Error(`Environment variable ${envName} not found.`);
  }

  return envConfig[envName];
}
